import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client/react';

import { GET_USER_GROUPS_FOR_USER } from '@atom/graph/userGroup';
import { useUserProfile } from '@atom/hooks/useUserProfile';

const GROUPS_PAGE = 1;
const GROUPS_LIMIT = 250;

type ViewerUserGroupIds = {
  userGroupIds: string[];
  loading: boolean;
};

export const useViewerUserGroupIds = (active: boolean): ViewerUserGroupIds => {
  const userProfile = useUserProfile();
  const userId = userProfile?.userId;

  const [getUserGroups, { data, loading, called }] = useLazyQuery(
    GET_USER_GROUPS_FOR_USER,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (active && userId) {
      getUserGroups({
        variables: {
          input: { userId, page: GROUPS_PAGE, limit: GROUPS_LIMIT },
        },
      });
    }
  }, [active, userId]);

  const fetchedIds = data?.userUserGroups?.userUserGroups?.map(
    group => group.id,
  );

  return {
    userGroupIds: fetchedIds ?? userProfile?.userGroupIds ?? [],
    loading: active && (!called || loading),
  };
};
